import { useSetRecoilState, useRecoilState } from 'recoil'
import style from './iframe.module.css'
import { iframeAtom, logInfoAtom } from '../../../store'
const Iframe = ({ iframe, setiframe }) => {
  const { type, src } = iframe
  const [logInfo,] = useRecoilState(logInfoAtom);
  const setIframe = useSetRecoilState(iframeAtom)


  const acceptTerms = () => {
    if (setiframe) {
      setiframe({ type: false, src: false })
      return;
    }
    const preTerms=localStorage.getItem('accepted_terms')!=='' && localStorage.getItem('accepted_terms')!==null?localStorage.getItem('accepted_terms'):''
    if(preTerms===''){
      localStorage.setItem('accepted_terms', preTerms+logInfo.user_uuid+',');
    }else{
      localStorage.setItem('accepted_terms', preTerms+logInfo.user_uuid+',');
    }
    setIframe({ type: false, src: false })
  };

  const handlerCloseframe = () => {
    if (setiframe) {
      setiframe({ type: false, src: false })
      return;
    }

    // if the type is Policy, then update the history
    // if (type === 'Policy' || type === 'Docs') {
    //   if (window.history.length > 1) {
    //     window.history.back();
    //   } else {
    //     window.history.pushState(null, '', '/');
    //   }
    // }

    setIframe({ type: false, src: false })
  }

  const iframeComponent = {
    'Youtube':
      <>
        <div className={style.mask} onPointerDown={handlerCloseframe}></div>
        <iframe
          className={style.youtubeIframe}
          src={src}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen>
        </iframe>
      </>
    ,

    "Terms":
      <>
        <div className={style.mask} onPointerDown={handlerCloseframe}></div>
        <div className={style.popup}>
          <div className={style.popupContent}>
            <iframe title="terms" src={src} />
          </div>
          <button className={style.acceptButton} onClick={acceptTerms}>I Accept</button>
        </div>
      </>
    ,

    "Policy": <>
      <div className={style.mask} onPointerDown={handlerCloseframe}></div>
      <iframe
        title="popup"
        className={`${style.policyIframe} ${type === 'Refund' ? style.refund : ''}`}
        onPointerDown={(ev) => ev.stopPropagation()}
        src={src}
      />
    </>,

    "Docs": <>
      <div className={style.mask} onPointerDown={handlerCloseframe}></div>
      <iframe
        title="popup"
        className={`${style.docsIframe}`}
        onPointerDown={(ev) => ev.stopPropagation()}
        src={src}
      />
    </>,

    "TestReportTab": <iframe
      title="reports"
      src="https://reports.hyperhuman.pages.dev/"
      width="240"
      height="500"
      frameBorder="0"
    />
  }
  return iframeComponent[type]
}

export { Iframe }